/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DeviceType {
	LOGGER = 'Logger',
	MODULAR_METER = 'Modular Meter',
	SC_METER = 'SC Meter',
	SENSOR = 'Sensor',
	TELEMETRY = 'Telemetry',
	WEIR_DISCHARGE = 'Weir Discharge',
	WL_STATION = 'WL Station',
}
